import React from "react";
import "./Contact.scss";
import Contacts from "../../components/Contact/Contacts";

function Contact() {
  return <Contacts />;
}

export default Contact;
